
import CustomsDeclarationElement from "@/store/modules/system/customsdeclarationelement/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins, Watch } from "@/lib";
import { List } from "vxe-table";
import Element from "@/store/modules/system/customsdeclarationelement/element";
@Component({
})
export default class CreateCustomsDeclarationElement extends Mixins(FormModalMixins) {
    model: CustomsDeclarationElement = new CustomsDeclarationElement();

    private trimCommodityCode() {
        const code: any = (this.model as any).commodityCode;
        if (typeof code === "string") {
            const trimmed = code.trim();
            if (trimmed !== code) (this.model as any).commodityCode = trimmed;
        }
    }

    @Watch("model.commodityCode")
    onCommodityCodeChanged() {
        this.trimCommodityCode();
    }

    @Watch("config.isShow")
    onVisibleChanged(value: boolean) {
        if (value) this.trimCommodityCode();
    }
    
    
    
   created() {
    Object.assign(this.config, { modelTitleL: "Action.Edit",labelWidth:130, okAction: "system/customsdeclarationelement/update" });
  }

    mounted(){
    }

    addElement() {
        this.model.elementList.push(new Element);
    }

    get noList() {
        return [
            {value: 1, displayText: "1"},
            {value: 2, displayText: "2"},
            {value: 3, displayText: "3"},
            {value: 4, displayText: "4"},
            {value: 5, displayText: "5"},
            {value: 6, displayText: "6"},
            {value: 7, displayText: "7"},
            {value: 8, displayText: "8"},
            {value: 9, displayText: "9"},
            {value: 10, displayText: "10"},
            {value: 11, displayText: "11"},
            {value: 12, displayText: "12"},
            {value: 13, displayText: "13"},
            {value: 14, displayText: "14"},
            {value: 15, displayText: "15"},
            {value: 16, displayText: "16"},
            {value: 17, displayText: "17"},
            {value: 18, displayText: "18"},
            {value: 19, displayText: "19"},
            {value: 20, displayText: "20"},
        ]
    }
    invoiceRatioValidator(index) {
        return [
        {required: true, type:'number', message: this.L('app.CustomsDeclarationElement.PleaseInput',this.L('app.CustomsDeclarationElement.Element')), trigger: 'blur'},
        {type: "number", validator: (rule:any, value:any, callback:any) => {
            const message = "请输入要素项";
            let invoiceTypeOfCurrentIndex = this.model.elementList[index].elementNo;
            if (this.model.elementList.findIndex((item, itemIndex)=>{ return item.elementNo === invoiceTypeOfCurrentIndex && item.element == value && itemIndex !== index}) !== -1) {
                callback(new Error(`${this.L('app.CustomsDeclarationElement.Element')}${this.L('app.CustomsDeclarationElement.CanNotBeRepeat')}`));
                return;
            }
            if (!this.model.elementList[index].element) {
                callback(message);
                return;
            }
            callback();
        }, trigger: 'blur,change'}
        ]
    }

    elementInput(index) {
        (this.$refs["form-modal"] as any).validateField('elementList.' + index + '.elementNo')
    }
    removeInvoice(index) {
    if (this.model.elementList.length > 1) {
      let temp=new Array<Element>();
      this.model.elementList.forEach((element,idx) => {
        if(idx!==index){
          temp.push(element)
        }
       
      });
      this.model.elementList=temp;
    }
  }
    close() {
    this.config.isShow = false;
    this.model = new CustomsDeclarationElement();
     this.addElement()
  }
get record(){ 
      let tt=this.$store.state.system.customsdeclarationelement.editCustomsDeclarationElement;
      return tt
    };
}
